import { render, staticRenderFns } from "./StoreCustomerBrands.vue?vue&type=template&id=7deb72b4"
import script from "./StoreCustomerBrands.vue?vue&type=script&lang=js"
export * from "./StoreCustomerBrands.vue?vue&type=script&lang=js"
import style0 from "./StoreCustomerBrands.vue?vue&type=style&index=0&id=7deb72b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports